(function (angular) {
	'use strict';

	angular
		.module('investmentGoalModule')
		.controller('InvestmentGoalInvest', [
			'$filter',
			'$timeout',
			'Big',
			'INVESTMENT_GOAL_AUTO_INVEST_FREQUENCY_OPTIONS',
			'investmentGoalFactory',
			'globalConfig',
			'INVESTMENT_ENTITY_ID',
			'MIN_INVESTMENT_AMOUNT',
			'mixpanelFactory',
			'urlFactory',
			InvestmentGoalInvestFunction
		]);

	function InvestmentGoalInvestFunction(
		$filter,
		$timeout,
		Big,
		INVESTMENT_GOAL_AUTO_INVEST_FREQUENCY_OPTIONS,
		investmentGoalFactory,
		globalConfig,
		INVESTMENT_ENTITY_ID,
		MIN_INVESTMENT_AMOUNT,
		mixpanelFactory,
		urlFactory
	) {
		
		var investmentGoalInvest = this;
		
		investmentGoalInvest.verifyInputsAreValid = function() {
			var amount = getAmount();
			
			return amount >= MIN_INVESTMENT_AMOUNT && amount <= 250000;
		};
		
		investmentGoalInvest.getEarningsProjection = function(){
			if (investmentGoalInvest.verifyInputsAreValid()) {
				investmentGoalFactory.getInvestmentGoalData(
					'NEW_GOAL_INVEST',
					investmentGoalInvest.investmentGoal.plan,
					investmentGoalInvest.investmentGoal.goalAmount,
					investmentGoalInvest.investmentGoal.monthsRemaining,
					getAmount(),
					getFrequency(),
					true
				).then(function(data){
					investmentGoalInvest.earningsProjection = parseInt(Big($filter('filter')(data.chartData, { expectedGoalAchievedDate: true })[0].projectedAmount));
				}, function(response){
					urlFactory.handleFailedRequest(response);
				});
			} else {
				investmentGoalInvest.earningsProjection = 0;
			}
		};

		investmentGoalInvest.changeAutoInvestFrequency = function() {
			if (investmentGoalInvest.autoInvestFrequency.value === 'SEMI_MONTHLY') {
				investmentGoalInvest.autoInvestAmount = getRecommendedSemiMonthlyAmount(investmentGoalInvest.recommendedMonthlyAmount);
			} else {
				investmentGoalInvest.autoInvestAmount = investmentGoalInvest.recommendedMonthlyAmount;
			}

			investmentGoalInvest.getEarningsProjection();
		};
		
		investmentGoalInvest.continue = function(){
			var investmentAmount = parseInt(Big(getAmount()));
			
			var mixpanelObj = {
				'Type' : investmentGoalInvest.investmentType,
				'Amount' : investmentAmount,
				'Recommended Amount': investmentGoalInvest.autoInvestAmount,
				'Investment Equals Recommendation': investmentAmount === investmentGoalInvest.investmentGoal.recurringInvestmentAmount
			};
			
			if (investmentGoalInvest.type === 'AUTO_INVEST') {
				mixpanelObj.frequency = investmentGoalInvest.autoInvestFrequency;
			}

			$timeout(function() {
				mixpanelFactory.track('Investment Goal Investment', mixpanelObj);
			}, 200);

			redirect();
		};

		investmentGoalInvest.setUpLater = function(){
			mixpanelFactory.track('Investment Goal Invest Later');

			urlFactory.redirect("/");
		};
		
		function getAmount(){
			return investmentGoalInvest.investmentType === 'MANUAL_INVESTMENT' ? investmentGoalInvest.singleInvestmentAmount : investmentGoalInvest.autoInvestAmount;
		}
		
		function getFrequency(){
			return investmentGoalInvest.investmentType === 'AUTO_INVEST' ? investmentGoalInvest.autoInvestFrequency.value : 'MONTHLY';
		}
		
		function redirect(){
			var url;
			var path;
			var urlParams = {
				backLink: 'investment-goal',
				cta: 'Investment Goal Invest',
				defaultAmount: getAmount()
			};
			
			if (investmentGoalInvest.investmentType === 'AUTO_INVEST' && angular.isDefined(investmentGoalInvest.activeRecurringInvestmentSchedule)) {
				urlParams.frequency = investmentGoalInvest.autoInvestFrequency.value;
				path = 'account/investment-accounts/'+ INVESTMENT_ENTITY_ID + '/' + investmentGoalInvest.investmentEntityUrlPath + '/recurring-investment-settings/manage';
				url = urlFactory.serializeParamsAndCreateUrl(path, urlParams);
			} else if (investmentGoalInvest.investmentType === 'AUTO_INVEST') {
				urlParams.frequency = investmentGoalInvest.autoInvestFrequency.value;
				path = 'account/recurring-investment/new';
				url = urlFactory.serializeParamsAndCreateUrl(path, urlParams);
			} else {
				path = 'account/additional-investment/start';
				url = urlFactory.serializeParamsAndCreateUrl(path, urlParams);
			}

			urlFactory.redirect(url);
		}
		
		function getRecommendedSemiMonthlyAmount(recommendedMonthlyAmount) {
			var recommendedMonthlyAmountBig = new Big(recommendedMonthlyAmount);
			var minAmountBig = new Big(MIN_INVESTMENT_AMOUNT);
			var minSemiMonthlyAmount = minAmountBig.times(2);
			
			if (recommendedMonthlyAmountBig.gt(minSemiMonthlyAmount)) {
				return parseInt(recommendedMonthlyAmountBig.div(2).round(0, 3).toFixed(0));
			} else {
				return MIN_INVESTMENT_AMOUNT;
			}
		}

		investmentGoalInvest.initialize = function(response) {
			investmentGoalInvest.activeRecurringInvestmentSchedule = response.activeRecurringInvestmentSchedule;
			investmentGoalInvest.investmentGoal = response.currentInvestmentGoal;
			investmentGoalInvest.recommendedMonthlyAmount = parseInt(Big(investmentGoalInvest.investmentGoal.recurringInvestmentAmount));
			var validatedRecommendedMonthlyAmount = investmentGoalInvest.recommendedMonthlyAmount < MIN_INVESTMENT_AMOUNT ? MIN_INVESTMENT_AMOUNT : investmentGoalInvest.recommendedMonthlyAmount;

			if (angular.isDefined(investmentGoalInvest.activeRecurringInvestmentSchedule)) {
				investmentGoalInvest.recurringInvestmentFrequencyLabel = investmentGoalInvest.activeRecurringInvestmentSchedule.recurringInvestmentFrequencyEnum === 'MONTHLY' ? 'monthly' : "semi-monthly";
			}

			investmentGoalInvest.autoInvestAmount = validatedRecommendedMonthlyAmount;
			investmentGoalInvest.autoInvestFrequencyOptions = INVESTMENT_GOAL_AUTO_INVEST_FREQUENCY_OPTIONS;
			investmentGoalInvest.autoInvestFrequency = investmentGoalInvest.autoInvestFrequencyOptions[0];
			investmentGoalInvest.singleInvestmentAmount = validatedRecommendedMonthlyAmount;
			investmentGoalInvest.investmentType = 'AUTO_INVEST';
			investmentGoalInvest.endDate = investmentGoalInvest.investmentGoal.endDate;
		};

		investmentGoalInvest.$onInit = function() {
			angular.extend(investmentGoalInvest, globalConfig);
			urlFactory.apiGetPromise('/api-secured/investment-goal/' + INVESTMENT_ENTITY_ID + '/invest').then(
				function(response) {
					if (!response.data.currentInvestmentGoal) {
						urlFactory.redirect("/investment-goal/select-goal");
					} else {
						investmentGoalInvest.initialize(response.data);
					}
				});
		};

	}
})(window.angular);